(function () {
    'use strict';
    angular
        .module('plagiat2017App')
        .constant('ADDFREETOKENSMIN', 1)
        .constant('ADDFREETOKENSMAX', 100);
})();
